import React, { useRef } from 'react';
import {
  Paper,
  Typography,
  Box,
  TextField,
  IconButton
} from '@mui/material';
import { Upload, X } from 'lucide-react';
import FormField from './FormField';
import { standardInputSx } from '../utils/hubsHelpers';

const LocationImageCard = ({
  previewImage,
  imageAltText,
  setImageAltText,
  handleImageChange,
  handleRemoveImage
}) => {
  const fileInputRef = useRef(null);

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: '#FFFFFF',
        border: '1px solid #E2E8F0',
        borderRadius: '8px',
        p: '14px 16px',
        mb: 1.75,
        boxShadow: 'none'
      }}
    >
      <Typography variant="subtitle1" sx={{ fontSize: 13.5, fontWeight: 600, color: '#1E293B', mb: 1.25 }}>
        Location Image
      </Typography>

      <Box
        onClick={() => fileInputRef.current?.click()}
        sx={{
          border: '1.5px dashed #CBD5E1',
          borderRadius: '8px',
          p: 2,
          textAlign: 'center',
          color: '#334155',
          fontWeight: 500,
          fontSize: 13,
          backgroundColor: '#F8FAFC',
          cursor: 'pointer',
          position: 'relative',
          overflow: 'hidden',
          minHeight: 90,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 1.25,
          '&:hover': { borderColor: '#FFBD65', backgroundColor: '#FFFDF9' }
        }}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          style={{ display: 'none' }}
        />

        {previewImage ? (
          <Box sx={{ width: '100%', position: 'relative' }}>
            <Box
              component="img"
              src={previewImage}
              alt="Hub Preview"
              sx={{ maxWidth: '100%', maxHeight: 150, borderRadius: '6px', display: 'block', mx: 'auto', mb: 1 }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
              <Typography variant="caption" sx={{ color: '#64748B' }}>
                Click to change image
              </Typography>
              <IconButton
                onClick={handleRemoveImage}
                size="small"
                sx={{
                  color: '#DC2626',
                  '&:hover': { backgroundColor: '#FEF2F2' }
                }}
              >
                <X size={16} />
              </IconButton>
            </Box>
          </Box>
        ) : (
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 0.75, color: '#64748B' }}>
              <Upload size={24} />
            </Box>
            <Typography sx={{ fontSize: 13, fontWeight: 500, color: '#334155' }}>Click to upload image</Typography>
            <Typography variant="caption" sx={{ color: '#94A3B8', fontSize: 11, display: 'block', mt: 0.25 }}>
              PNG, JPG or WEBP (Max 5MB)
            </Typography>
          </Box>
        )}
      </Box>

      <FormField
        label="Image Alt Text *"
        badge="NEW"
        helperText="e.g. Ayurvedic oil therapy at a backwater retreat in Kerala"
      >
        <TextField
          size="small"
          fullWidth
          value={imageAltText}
          placeholder="e.g. Ayurvedic oil therapy at a backwater retreat in Kerala"
          onChange={(e) => setImageAltText(e.target.value)}
          sx={standardInputSx}
        />
      </FormField>
    </Paper>
  );
};

export default React.memo(LocationImageCard);
